angular.module('webcomm')
    .directive('connectionHealth', ['$log', function($log) {
        function link(scope, element, attrs) {
            scope.status = 'gray';

            var unbindWatcher = scope.$watch('latency', function(value, oldvalue) {
                $log.info("connection health directive latency changed", value, oldvalue);
                if(value) {
                    if (value < 100) {
                        scope.status = 'green';
                    } else if (value < 200) {
                        scope.status = 'yellow';
                    } else {
                        scope.status = 'red';
                    }
                }
            });

            scope.$on('$destroy', function() {
                unbindWatcher();
            });
        }

        return {
            restrict: 'EA',
            link: link,
            scope: {
                latency: '='
            },
            template: '<div class="connection-info {{status}}" title="Connection Latency: {{latency}}ms"><span class="fa fa-circle"></span></div>'
        };
    }]);